import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 20px;
  margin-top: 0;
`;

export const NavbarAndContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #fff;
  margin: 40px;
  padding: 40px 48px;
  border-radius: 20px;
`;
